export const LOGIN_INFO = 'LOGIN_INFO';
export const LOGIN_TWOFA_AUTH = 'LOGIN_TWOFA_AUTH';
export const LOGIN_TWOFA_AUTH_SUCCESS = 'LOGIN_TWOFA_AUTH_SUCCESS';
export const LOGIN_TWOFA_AUTH_FAILURE = 'LOGIN_TWOFA_AUTH_FAILURE';
//= ====================================
//  EMAIL AUTH
//-------------------------------------

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_WITH_EMAIL_REQUEST = 'LOGIN_WITH_EMAIL_REQUEST';
export const LOGIN_WITH_EMAIL_SUCCESS = 'LOGIN_WITH_EMAIL_SUCCESS';
export const LOGIN_WITH_EMAIL_FAILURE = 'LOGIN_WITH_EMAIL_FAILURE';

export const REGISTER_WITH_EMAIL_REQUEST = 'REGISTER_WITH_EMAIL_REQUEST';
export const REGISTER_WITH_EMAIL_SUCCESS = 'REGISTER_WITH_EMAIL_SUCCESS';
export const REGISTER_WITH_EMAIL_FAILURE = 'REGISTER_WITH_EMAIL_FAILURE';

export const PASSWORD_FORGET_REQUEST = 'PASSWORD_FORGET_REQUEST';
export const PASSWORD_FORGET_SUCCESS = 'PASSWORD_FORGET_SUCCESS';
export const PASSWORD_FORGET_FAILURE = 'PASSWORD_FORGET_FAILURE';

export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const SYNC_USER = 'SYNC_USER';

export const HIDE_MSG = 'HIDE_MSG';
